import {
    endOfMonth as dfEndOfMonth,
    endOfWeek,
    endOfYear,
    format,
    startOfMonth as dfStartOfMonth,
    startOfWeek,
    startOfYear,
    subMonths,
    subWeeks,
    subYears
} from 'date-fns';

/**@params dateType = 'daily' | 'weekly' | 'monthly' | 'yearly' */
/**@returns e.g.) { prev: '(25.10.02~25.10.09)', curr: '(25.10.10~25.10.16)' } or null(daily) */
const formatDate = (date) => format(date, 'yy.MM.dd');

const getCompareDate = (dateType) => {
    const today = new Date();

    switch (dateType) {
        case 'daily': {
            // daily는 비교 기간 표시 안 함
            return null;
        }
        case 'weekly': {
            const startCurr = startOfWeek(today, { weekStartsOn: 1 });
            const endCurr = endOfWeek(today, { weekStartsOn: 1 });

            const startPrev = subWeeks(startCurr, 1);
            const endPrev = endOfWeek(startPrev, { weekStartsOn: 1 });

            return {
                prev: `(${formatDate(startPrev)}~${formatDate(endPrev)})`,
                curr: `(${formatDate(startCurr)}~${formatDate(endCurr)})`,
            };
        }
        case 'monthly': {
            const startCurr = dfStartOfMonth(today);
            const endCurr = dfEndOfMonth(today);

            const basePrev = subMonths(today, 1);
            const startPrev = dfStartOfMonth(basePrev);
            const endPrev = dfEndOfMonth(basePrev);

            return {
                prev: `(${formatDate(startPrev)}~${formatDate(endPrev)})`,
                curr: `(${formatDate(startCurr)}~${formatDate(endCurr)})`,
            };
        }
        case 'yearly': {
            const startCurr = startOfYear(today);
            const endCurr = endOfYear(today);

            const basePrev = subYears(today, 1);
            const startPrev = startOfYear(basePrev);
            const endPrev = endOfYear(basePrev);

            return {
                prev: `(${formatDate(startPrev)}~${formatDate(endPrev)})`,
                curr: `(${formatDate(startCurr)}~${formatDate(endCurr)})`,
            };
        }
        default:
            return null;
    }
};

export default getCompareDate;
